module.exports = __webpack_public_path__ + "img/p-nuageux.5a950cd7.jpg";